import { absoluteImageUrl } from '../utils/environment'
import { ReferralLandingPage } from '../../types'
import { RepeatableComponent } from '../../types/ReferralPage'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiReferralLandingPage = (strapiData: any): ReferralLandingPage => {
    const { data } = strapiData
    const { attributes } = data
    const { landingPageTitle, landingPageDescription, description, landingPageRepeatableContent, repeatableContent, termsAndConditions, termsAndConditionsHeader, termsAndConditionsLinkText, profileReferralBanner, profileMenuBenefit, profileCardImage } = attributes

    const mappedRepeatableContent: RepeatableComponent[] = repeatableContent.map((item: { thumbnail: { data: { attributes: { url: string } } } }) => ({
        ...item,
        thumbnail: absoluteImageUrl(item.thumbnail.data.attributes.url),
    }))

    const mappedLandingPageRepeatableContent: RepeatableComponent[] = landingPageRepeatableContent.map((item: { thumbnail: { data: { attributes: { url: string } } } }) => ({
        ...item,
        thumbnail: absoluteImageUrl(item.thumbnail.data.attributes.url),
    }))

    return {
        landingPageTitle,
        landingPageDescription,
        description,
        repeatableContent: mappedRepeatableContent,
        landingPageRepeatableContent: mappedLandingPageRepeatableContent,
        termsAndConditions,
        termsAndConditionsHeader,
        termsAndConditionsLinkText,
        profileReferralBanner: absoluteImageUrl(profileReferralBanner.data.attributes.url),
        profileMenuBenefit,
        profileCardImage: absoluteImageUrl(profileCardImage.data.attributes.url),
    }
}

export { fromStrapiReferralLandingPage }